export default __webpack_public_path__ + "static/media/hover-actions.8a9dc364.gif";